module.exports = __webpack_public_path__ + "static/10-2de31423689308d8dd43599b1d14a7e8.png";